import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Universal Print / Save-as-PDF button.
 *
 * Sets `body.vault-print-export` before opening the browser print
 * dialog so this specific print job bypasses the global @media print
 * blackout (which hides every dashboard screen for privacy).
 * The class is cleared automatically after `afterprint` fires or after
 * a short safety timeout.
 */
function runAuthorisedPrint() {
    const body = document.body;
    body.classList.add("vault-print-export");
    const cleanup = () => {
        body.classList.remove("vault-print-export");
        window.removeEventListener("afterprint", cleanup);
    };
    window.addEventListener("afterprint", cleanup);
    // Safety timeout in case afterprint never fires (some browsers).
    setTimeout(cleanup, 8000);
    window.print();
}

export default function PrintPageButton({ variant = "ghost", size = "sm", label }) {
    return (
        <Button
            variant={variant}
            size={size}
            className="print:hidden"
            onClick={runAuthorisedPrint}
            data-testid="print-page-btn"
            aria-label="Print or save as PDF"
        >
            <Printer size={13} className={label ? "mr-1.5" : ""} />
            {label ?? <span className="hidden sm:inline">Print / PDF</span>}
        </Button>
    );
}
